
define('ldsh!modules/start/dashboard/engagement/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="panel panel-default right-panel">\n    <div class="panel-heading center">\n        <span class="i18n panel-title pull-center" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.TITLES.ENGAGEMENT ">Engagement</span>&nbsp;\n        <span id="engagementHelp" class="helpTextIcon cursorHand" data-original-title="" title="">\n            <font class="helpTextContent">?</font>\n        </span>\n    </div>\n    ';
 if(showEngagementInfo){ ;
__p += '\n    <div class="panel-info panel-default">\n        <div id="pie-chart-info" class="panel-body pull-center">\n            <div class="text-center">\n                <i class="gris fa fa-pie-chart" style="font-size: 80px;"></i>\n                <h6>\n                    <strong class="gris i18n" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.NO_USERS.INFO_1"></strong>\n                </h6>\n                <h6>\n                    <strong class="gris i18n" style="font-size: 11px" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.NO_USERS.INFO_2"></strong>\n                </h6>\n                <a href="' +
__e(mdirectorUrl) +
'/login?redirect=private[sharp]create/mail" class="btn boton-entrar i18n" style="margin-left: 0px;" data-service="" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.NO_USERS.CREATE_DELIVERY"></a>\n            </div>\n        </div>\n    </div>\n    ';
 } else { ;
__p += '\n    <div class="panel-body">\n        <div id="pie-chart" class="pull-center"></div>\n    </div>\n    ';
 }  ;
__p += '\n</div>\n';

}
return __p
};});

